import React from 'react';
import clsx from 'clsx';
import * as classes from './layout.module.scss';

const TwoColumns = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>((props, ref) => {
    const { className, ...rest } = props;
    const mergedClassName = clsx(classes.twoColumns, className);

    return <div className={mergedClassName} {...rest} ref={ref} />;
});
TwoColumns.displayName = 'TwoColumns';

export default TwoColumns;
